// importing images

import calenderSvg from "../images/calendar-days-solid.svg";
import slackLogo from "../images/slack-brands.svg";
import doneLogo from "../images/square-check-solid.svg";
import gameLogo from "../images/gamepad-solid.svg";



export const featuresOne = [
  {
    imageSource: calenderSvg,
    feature: "Monthly Calls",
    featureDescription:
      "Monthly calls that inspire and connect creators from all around the world."
  },
  {
    imageSource: slackLogo,
    feature: "Group Chat",
    featureDescription:
      "A thriving group chat in which you can connect with fellow creators anytime you want."
  }
];

export const featuresTwo = [
  {
    imageSource: doneLogo,
    feature: "Accountability",
    featureDescription:
      "A shared Miro board that encourages everyone to achieve their goals."
  },
  {
    imageSource: gameLogo,
    feature: "Game Nights",
    featureDescription: "Who said content creation is a lonely process?"
  }
];
